import { render, staticRenderFns } from "./ProductItemCreation.vue?vue&type=template&id=51c0646a&scoped=true"
import script from "./ProductItemCreation.vue?vue&type=script&lang=js"
export * from "./ProductItemCreation.vue?vue&type=script&lang=js"
import style0 from "./ProductItemCreation.vue?vue&type=style&index=0&id=51c0646a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c0646a",
  null
  
)

export default component.exports